import isElement from './is-element.js';

export default function find (element, selector) {
  return isElement(element) ? Array.from(element.querySelectorAll(selector)) : [];
}
